<template>
  <div class="footerCommon flex" style="justify-content: center">
    <span v-html="recodeNo"></span>
    <a class="flex" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030902002778"
       target="_blank"><img src="../assets/img/copyRight.png" alt="" style="margin-right: 5px;">粤公网安备 44030902002778号</a>
    <a href="javascript:void(0);" @click="showRecord=true">互联网药品信息服务资格证书 (粤)-非经营性-2021-0211</a>
    <el-dialog top="0" :visible.sync="showRecord"
               :show-close="false" width="600px" class="showRecord">
      <template #title></template>
      <img src="../assets/img/record.jpg" width="100%" alt="">
    </el-dialog>
  </div>
</template>

<script>
import SysConstant from '@/api/system_constant';

export default {
  name: "footerCommon",
  data() {
    return {
      recodeNo: SysConstant.RECORD_NO,
      showRecord: false
    }
  }
}
</script>

<style scoped lang="scss">
@import '../assets/css/head.scss';

.showRecord ::v-deep {
  .el-dialog__header, .el-dialog__body {
    padding: 0;
  }

  img {
    display: block;
  }
}
</style>
